<script setup>
import { computed, ref, watch } from 'vue';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  phoneNumber: { type: String, required: true },
  initialDraft: { type: String, default: '' },
});

const draft = ref(props.initialDraft);

watch(
  () => props.initialDraft,
  value => {
    draft.value = value;
  }
);

const whatsappUrl = computed(() => {
  const phone = props.phoneNumber.replace(/\D/g, '');
  const message = draft.value.trim();
  const query = message ? `?text=${encodeURIComponent(message)}` : '';

  return `https://wa.me/${phone}${query}`;
});

const openOfficialWhatsApp = () => {
  window.open(whatsappUrl.value, '_blank', 'noopener,noreferrer');
};
</script>

<template>
  <section
    data-testid="official-whatsapp-initiation"
    class="mx-3 mb-2 rounded-xl border border-n-brand/30 bg-n-brand/5 p-3"
  >
    <div class="flex items-start gap-3">
      <div
        class="flex size-9 shrink-0 items-center justify-center rounded-full bg-n-brand/10 text-n-blue-11"
      >
        <span class="i-lucide-message-circle-more size-5" aria-hidden="true" />
      </div>

      <div class="min-w-0 flex-1">
        <h3 class="m-0 text-sm font-medium text-n-slate-12">
          {{ $t('CONVERSATION.REPLYBOX.OFFICIAL_WHATSAPP_INITIATION.TITLE') }}
        </h3>
        <p class="mb-3 mt-1 text-xs leading-5 text-n-slate-11">
          {{
            $t('CONVERSATION.REPLYBOX.OFFICIAL_WHATSAPP_INITIATION.DESCRIPTION')
          }}
        </p>

        <textarea
          v-model="draft"
          data-testid="official-whatsapp-draft"
          rows="2"
          class="mb-3 block w-full resize-y rounded-lg border border-n-weak bg-n-alpha-3 px-3 py-2 text-sm text-n-slate-12 outline-none placeholder:text-n-slate-9 focus:border-n-brand"
          :placeholder="
            $t('CONVERSATION.REPLYBOX.OFFICIAL_WHATSAPP_INITIATION.PLACEHOLDER')
          "
        />

        <div class="flex flex-wrap items-center gap-3">
          <Button
            data-testid="open-official-whatsapp"
            size="sm"
            icon="i-lucide-external-link"
            :label="
              $t('CONVERSATION.REPLYBOX.OFFICIAL_WHATSAPP_INITIATION.BUTTON')
            "
            @click="openOfficialWhatsApp"
          />
          <p class="m-0 min-w-48 flex-1 text-xs leading-5 text-n-slate-10">
            {{ $t('CONVERSATION.REPLYBOX.OFFICIAL_WHATSAPP_INITIATION.HINT') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
